// Runs before any store module rehydrates (imported first in index.tsx).
//
// Each deploy stamps a fresh REACT_APP_BUILD_ID into config.js, which is served
// no-cache — so the browser always reads the current build id at startup. On the
// first open after a deploy the id differs from the stored one, so we clear the
// persisted session/local storage. This prevents a store-shape change in the new
// build from crashing rehydration or leaving stale UI state, without forcing the
// user to hard-refresh. Normal reloads (same build id) keep the session intact.
const BUILD_ID: string | undefined = (window as any).env?.REACT_APP_BUILD_ID;
const BUILD_ID_KEY = "coralis-build-id";

try {
  if (BUILD_ID && window.localStorage.getItem(BUILD_ID_KEY) !== BUILD_ID) {
    const language = window.localStorage.getItem("coralis-language-preference");
    window.sessionStorage.clear();
    window.localStorage.clear();
    if (language) {
      window.localStorage.setItem("coralis-language-preference", language);
    }
    window.localStorage.setItem(BUILD_ID_KEY, BUILD_ID);
  }
} catch (e) {
  // storage unavailable (private mode, blocked cookies) — nothing to clear.
}

export {};
